(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olyria-product-grid"] && !Shopify.designMode) return;
  try {
    
/* Olyria Product Grid - stand-alone infinite scroll, isolated from Dawn grids. */
(function () {
  'use strict';
  if (window.__olyriaGridScrollV3) {
    if (window.__olyriaGridScrollV3.scan) window.__olyriaGridScrollV3.scan();
    return;
  }

  var active = new Map();
  var scanScheduled = false;

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(scan);
  }

  function scan() {
    scanScheduled = false;
    active.forEach(function (state, root) {
      if (!root.isConnected ||
          root.querySelector('[data-opg-scroll-grid]') !== state.grid ||
          root.querySelector('[data-opg-infinite-scroll]') !== state.wrapper ||
          root.querySelector('[data-opg-scroll-pagination]') !== state.pagination) {
        state.disconnected = true;
        if (state.observer) state.observer.disconnect();
        if (state.controller) state.controller.abort();
        window.removeEventListener('scroll', state.onScroll);
        window.removeEventListener('resize', state.onScroll);
        active.delete(root);
      }
    });

    document.querySelectorAll('[data-opg][data-opg-section-id]').forEach(function (root) {
      if (active.has(root)) return;
      var grid = root.querySelector('[data-opg-scroll-grid]');
      var pagination = root.querySelector('[data-opg-scroll-pagination]');
      var wrapper = root.querySelector('[data-opg-infinite-scroll]');
      if (!grid || !pagination || !wrapper || !wrapper.dataset.nextUrl) return;
      init(root, grid, pagination, wrapper);
    });
  }

  function init(root, grid, pagination, wrapper) {
    var trigger = wrapper.querySelector('[data-opg-scroll-trigger]');
    var message = wrapper.querySelector('[data-opg-scroll-message]');
    var button = wrapper.querySelector('[data-opg-scroll-load]');
    var errorBox = wrapper.querySelector('[data-opg-scroll-error]');
    var sectionId = root.dataset.opgSectionId;
    if (!trigger || !message || !button || !errorBox || !sectionId) return;

    var state = {
      grid: grid, pagination: pagination, wrapper: wrapper, nextUrl: wrapper.dataset.nextUrl,
      loading: false, disconnected: false, controller: null, observer: null,
      requested: new Set(), onScroll: null
    };
    active.set(root, state);
    pagination.classList.add('opg__pagination--scroll-active');

    function stillCurrent() {
      return !state.disconnected && root.isConnected &&
        root.querySelector('[data-opg-scroll-grid]') === grid &&
        root.querySelector('[data-opg-infinite-scroll]') === wrapper;
    }

    function stopAuto() {
      if (state.observer) state.observer.disconnect();
      window.removeEventListener('scroll', state.onScroll);
      window.removeEventListener('resize', state.onScroll);
    }

    function findMatchingSection(doc) {
      var matches = doc.querySelectorAll('[data-opg][data-opg-section-id]');
      for (var i = 0; i < matches.length; i++) {
        if (matches[i].dataset.opgSectionId === sectionId) return matches[i];
      }
      return null;
    }

    async function getNextSection(nextUrl) {
      var url = new URL(nextUrl, window.location.href);
      if (url.origin !== window.location.origin) throw new Error('Pagination URL is not from this store');
      // First use Shopify's faster section rendering, then fall back to full HTML.
      var fastUrl = new URL(url.href);
      fastUrl.searchParams.set('section_id', sectionId);
      var lastError = null;
      for (var pass = 0; pass < 2; pass++) {
        var targetUrl = pass === 0 ? fastUrl.href : url.href;
        try {
          var response = await fetch(targetUrl, {
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' },
            signal: state.controller.signal
          });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          var html = await response.text();
          if (!stillCurrent()) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = findMatchingSection(doc);
          var nextGrid = nextRoot && nextRoot.querySelector('[data-opg-scroll-grid]');
          if (!nextRoot || !nextGrid || !nextGrid.querySelector('.opg__card')) {
            throw new Error('Next page did not include Olyria product cards');
          }
          return { root: nextRoot, grid: nextGrid };
        } catch (e) {
          if (e.name === 'AbortError') throw e;
          lastError = e;
        }
      }
      throw lastError || new Error('Could not load the next page');
    }

    async function loadNext() {
      if (!stillCurrent() || state.loading || !state.nextUrl) return;
      state.loading = true;
      state.controller = new AbortController();
      message.hidden = false;
      message.textContent = 'Loading more designs...';
      button.disabled = true;
      errorBox.hidden = true;
      try {
        var nextCanonical = new URL(state.nextUrl, window.location.href);
        nextCanonical.searchParams.delete('section_id');
        if (state.requested.has(nextCanonical.href)) throw new Error('Repeated page detected');
        var next = await getNextSection(state.nextUrl);
        if (!next || !stillCurrent()) return;

        var cards = Array.from(next.grid.children).filter(function (child) {
          return child.classList.contains('opg__card');
        });
        var existingIds = new Set(Array.from(grid.querySelectorAll('[data-opg-product-id]')).map(function (card) {
          return card.dataset.opgProductId;
        }));
        var added = 0;
        var fragment = document.createDocumentFragment();
        cards.forEach(function (card) {
          var id = card.dataset.opgProductId;
          if (id && existingIds.has(id)) return;
          if (id) existingIds.add(id);
          var clone = document.importNode(card, true);
          clone.classList.add('scroll-trigger--cancel');
          clone.querySelectorAll('.scroll-trigger').forEach(function (el) {
            el.classList.add('scroll-trigger--cancel');
          });
          fragment.appendChild(clone);
          added++;
        });
        if (!added) throw new Error('Next page contained no new products');
        grid.appendChild(fragment);
        state.requested.add(nextCanonical.href);

        var nextFooter = next.root.querySelector('[data-opg-infinite-scroll]');
        state.nextUrl = nextFooter ? (nextFooter.dataset.nextUrl || '') : '';
        wrapper.dataset.nextUrl = state.nextUrl;
        document.dispatchEvent(new CustomEvent('olyria:collection-products-loaded', {
          detail: { grid: grid, count: added, sectionId: sectionId }
        }));

        if (!state.nextUrl) {
          stopAuto();
          button.hidden = true;
          errorBox.hidden = true;
          message.hidden = false;
          message.textContent = 'You have viewed all products.';
        } else {
          message.hidden = true;
          // The loader checks proximity again once this request finishes.
        }
      } catch (e) {
        if (e.name !== 'AbortError' && stillCurrent()) {
          console.error('[Olyria Product Grid] Cannot load next page:', e);
          stopAuto();
          pagination.classList.remove('opg__pagination--scroll-active');
          errorBox.textContent = 'More products could not be loaded automatically. Try Load more or use the page links.';
          errorBox.hidden = false;
          message.hidden = true;
          button.hidden = false;
          button.textContent = 'Try loading more';
        }
      } finally {
        state.loading = false;
        state.controller = null;
        button.disabled = false;
        // Short final rows can leave the trigger inside the viewport;
        // continue fetching until enough products fill the page.
        if (stillCurrent() && state.nextUrl && errorBox.hidden) {
          requestAnimationFrame(checkProximity);
        }
      }
    }

    function checkProximity() {
      if (!state.loading && state.nextUrl && stillCurrent()) {
        var rect = trigger.getBoundingClientRect();
        if (rect.top < window.innerHeight + 900 && rect.bottom > -900) loadNext();
      }
    }

    var scrollTick = false;
    state.onScroll = function () {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () { scrollTick = false; checkProximity(); });
    };

    button.addEventListener('click', loadNext);
    window.addEventListener('scroll', state.onScroll, { passive: true });
    window.addEventListener('resize', state.onScroll);
    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) loadNext();
      }, { root: null, rootMargin: '900px 0px', threshold: 0 });
      state.observer.observe(trigger);
    }
    // Try auto loading on startup for short collections; manual button always remains available.
    requestAnimationFrame(checkProximity);
  }

  function start() {
    scan();
    var host = document.getElementById('MainContent') || document.body;
    if (host && !host.dataset.opgInfiniteScrollWatchingV3) {
      host.dataset.opgInfiniteScrollWatchingV3 = '1';
      new MutationObserver(scheduleScan).observe(host, { childList: true, subtree: true });
    }
  }

  window.__olyriaGridScrollV3 = { scan: scheduleScan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('pageshow', scheduleScan);
})();

  } catch(e) { console.error(e); }
})();
})();
